import { render, staticRenderFns } from "./ReviewQuestionBylawItem.vue?vue&type=template&id=2cbc04a3"
import script from "./ReviewQuestionBylawItem.vue?vue&type=script&lang=js"
export * from "./ReviewQuestionBylawItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports